export const DefaultTranslation = {
  navbar: {
    navHome: "Home",
    navSchool: "My School",
    navMyGuides: "My Guides",
    navContactUs: "Contact Us",
    navLogin: "Login",
    navLogout: "Logout",
    navRegister: "Register",
    navGuides: "Guides",
    navMessages: "Messages",
    emailNotificationsOffWarning:
      "You're not receiving email notifications. Click here to turn them on.",
    navHi: "Hi",
  },
  topics: {
    topicsTitle: "Topics Included in Series",
    lessonsCards: [
      {
        id: 1,
        title: "Can God Be Trusted?",
        img: "../../assets/Images/cover1.png",
        unlocked: true,
        topic: "Bible Validity",
      },
      {
        id: 2,
        title: "Seeing the Signs",
        img: "../../assets/Images/cover2.png",
        topic: "Last Day Events",
      },
      {
        id: 3,
        title: "Why does God Allow Suffering?",
        img: "../../assets/Images/cover3.png",
        topic: "Suffering",
        alt: "../../assets/Images/alt3.jpg",
        add: "Why does God allow suffering? Where is He when I'm hurting?",
      },
      {
        id: 4,
        title: "Hope for a Planet in Crisis",
        img: "../../assets/Images/cover4.png",
        topic: "Sin Origins",
      },
      {
        id: 5,
        title: "As Good as It Gets",
        img: "../../assets/Images/cover5.png",
        topic: "Heaven",
      },
      {
        id: 6,
        title: "Peace On Earth",
        img: "../../assets/Images/cover6.png",
        topic: "10 Commandments",
      },
      {
        id: 7,
        title: "Quality Time",
        img: "../../assets/Images/cover7.png",
        topic: "Sabbath",
      },
      {
        id: 8,
        title: "The Day That Disappeared",
        img: "../../assets/Images/cover8.png",
        topic: "Sabbath",
      },
      {
        id: 9,
        title: "The War Is Over",
        img: "../../assets/Images/cover9.png",
        topic: "Surrender",
      },
      {
        id: 10,
        title: "The Mystery of Death",
        img: "../../assets/Images/cover10.png",
        topic: "State of the Dead",
        alt: "../../assets/Images/alt10.jpg",
        add: "How can I find hope and peace in a world of chaos? ",
      },
      {
        id: 11,
        title: "Revelation's 1,000 Years",
        img: "../../assets/Images/cover11.png",
        topic: "Millennium",
      },
      {
        id: 12,
        title: "Hellfire: Would God Really Do That?",
        img: "../../assets/Images/cover12.png",
        topic: "Hell",
      },
      {
        id: 13,
        title: "The Second Coming of Jesus",
        img: "../../assets/Images/cover13.png",
        topic: "Second Coming",
      },
      {
        id: 14,
        title: "Buried Alive?",
        img: "../../assets/Images/cover14.png",
        topic: "Baptism",
      },
      {
        id: 15,
        title: "Living Life to the Fullest!",
        img: "../../assets/Images/cover15.png",
        topic: "Health",
        alt: "../../assets/Images/alt15.jpg",
        add: "What happens when I die? ",
      },
      {
        id: 16,
        title: "Rebuilding the Temple",
        img: "../../assets/Images/cover16.png",
        topic: "Sanctuary",
      },
      {
        id: 17,
        title: "The Messiah and the Judgment",
        img: "../../assets/Images/cover17.png",
        topic: "Judgement",
      },
      {
        id: 18,
        title: "The Mystery Beast of Revelation",
        img: "../../assets/Images/cover18.png",
        topic: "Revelation 13",
      },
      {
        id: 19,
        title: "The Mark of the Beast",
        img: "../../assets/Images/cover19.png",
        topic: "Mark of the Beast",
        alt: "../../assets/Images/alt19.jpg",
        add: "The USA in Bible Prophecy",
      },
      {
        id: 20,
        title: "The United States in Bible Prophecy",
        img: "../../assets/Images/cover20.png",
        topic: "U.S. in Prophecy",
        alt: "../../assets/Images/alt20.jpg",
        add: "The Mark of the Beast",
      },
      {
        id: 21,
        title: "In Search of the Church",
        img: "../../assets/Images/cover21.png",
        topic: "Church",
      },
      {
        id: 22,
        title: "The Fall of Babylon",
        img: "../../assets/Images/cover22.png",
        topic: "Babylon",
      },
      {
        id: 23,
        title: "Prophets and Prophecy",
        img: "../../assets/Images/cover23.png",
        topic: "Prophets",
      },
      {
        id: 24,
        title: "More Than Enough",
        img: "../../assets/Images/cover24.png",
        topic: "Tithe",
      },
      {
        id: 25,
        title: "The Gift of the Spirit",
        img: "../../assets/Images/cover25.png",
        topic: "Holy Spirit",
      },
    ],
  },

  trylesson: {
    tryLessonTitle1: "Interactive Studies",
    tryLessonTitle2: "Saved work",
    tryLessonTitle3: "Free Access",
    tryLessonTitle4: "Study Partners",
    tryLessonTitle5: "Free Resources",
    tryLessonTitle6: "Discount Codes",
    tryLessonDesc1:
      "We've added tons of supplemental material to keep you continually engaged and learning.",
    tryLessonDesc2: "Start a lesson on your phone and finish on your laptop.",
    tryLessonDesc3:
      "What's better than free?  I guess if we paid you that would be better, but free is still pretty good!",
    tryLessonDesc4:
      "Got a question?  Ask one of our Seasonsed Bible instructors for help!  Or, just let one of us walk you through the whole study!",
    tryLessonDesc5:
      "As you complete various lessons, you will receive free downloadable books and other complimentary gifts as an added bonus to your studies. In fact, you will receive your first free gift as soon as you sign up!",
    tryLessonDesc6:
      "As a special thank you, we will share ongoing discount codes for our online store that you can use any time.",
  },

  demo: {
    demoTryASample: "Try A Sample!",
    demoQuestionTitle: "1. Where is Jesus now, and what is he doing?",
    demoVerseRef: "Hebrews 8: 1, 2",
    demoInstruction:
      "Complete the verse by dragging the correct words to the appropriate blank",
    demoQuestion1: "We have such a High Priest,",
    demoQuestion2: " who is seated at the right hand of the",
    demoQuestion3: "of the Majesty in the ",
    demoQuestion4: ", a Minister of the",
    demoQuestion5: " and of the true tabernacle which the Lord",
    demoWords: [
      "erected",
      "seat",
      "built",
      "sky",
      "sanctuary",
      "heavens",
      "throne",
    ],
    demoCorrect1: "throne",
    demoCorrect2: "heavens",
    demoCorrect3: "sanctuary",
    demoCorrect4: "erected",
  },

  testimonials: {
    whatArePeopleSaying: "What Are People Saying?",
    testiAvatar1: "J",
    testiAvatar2: "T",
    testiAvatar3: "J",
    testiAvatar4: "M",
    testiAvatar5: "D",

    testiName1: "Jill, TN",
    testiName2: "Terrell, MI",
    testiName3: "Jin, CA",
    testiName4: "Maria, TX ",
    testiName5: "Destiny, OR",

    testi1:
      "These studies opened my eyes to things in the Bible that I never knew or understood before, even though I have studied the Bible my whole life.",
    testi2:
      "Being new to the Bible, I thought these lessons would be too difficult for me, but I found them to be simple, clear, and easy to understand.",
    testi3:
      "I was a bit skeptical from the beginning, thinking they would not really be Bible based. I was wrong! Everything in them comes straight from the Bible without any bias. I love them!",
    testi4:
      "I did not know the Bible brings out so many practical answers to life in today’s world. These guides helped bring the Bible to life to find the answers and help I was looking for.",
    testi5:
      "I am so thankful to have come across the It Is Written Lessons. They have brought hope and healing to my life in so many ways. Jesus became more real to me than ever before.",
  },

  faq: {
    faqF: "F",
    faqA: "A",
    faqQ: "Q",

    faqTitle1: "Will I ever be asked for money?",
    faqTitle2: "What denomination is this?",
    faqTitle3: "Is there any obligation?",

    faqBody1:
      "No, these guides are a completely free opportunity for you to study the Bible.",
    faqBody2:
      "It Is Written is a Bible-based Christian ministry supported by sponsors of multiple denominations.",
    faqBody3: "No, you can start and stop the lessons at your desire.",
  },

  main: {
    verse:
      "Jesus said, \"It is written, 'Man shall not live by bread alone, but by every word that proceeds from the mouth of God'\"",
    verseSiting: "Matthew 4:4.",
    subVerse: "Understand the Bible",
    together: "Let's Study the Bible Together!",
    para1:
      "Our free It Is Written Study Guides are here to help you have a deeper understanding of the Bible. Each lesson covers a specific topic that gets right to the point in a question and answer format. The answer is always found straight from the Bible. The guides are designed with simplicity and clarity yet packed with life-encouraging truths for every type of person! ",
    para2:
      "Start your exciting journey through the Bible today by creating an account with no obligation. You can even try the first lesson without an account to see if it’s for you! ",
    sampleTopics: "Sample Topics:",
    ul1: "Why does God allow suffering? Where is He when I’m hurting?",
    ul2: "How can I find hope and peace in a world of chaos? ",
    ul3: "What happens when I die? ",
    ul4: "The USA in Bible Prophecy",
    ul5: "The Mark of the Beast",
    ul6: "Much more! ",
    resume: "Resume Lesson",
    mainStartButton: "Get Started Now",
    otherQuestions:
      "If you have other questions, please feel free to reach out to us!",
    learnMore: "Learn more about our lessons",
    quote:
      "'Join us for an exciting journey, as we explore the timeless truths in God's Word–the Bible.'",
    pastor: "Pastor John Bradshaw, President of It Is Written",
    mobileAppHeading: "Always at Your Fingertips",
    understandTheBible: "Understand Your Bible",
    imageHeaderBody: "With Our Free Study Guides",
    whatCanIExpect: "What Can I Expect?",
    tryDemo: "Try Demo",
    watchVideo: "Watch Video",
    tryLesson1: "Try Lesson 1",
    tryYourFirstLesson: "Try The First Lesson",
    createMyAccount: "Create My Account",
    stillWondering: "Creating An Account Gives You...",
    mobileAppBody:
      "With our mobile app you'll be able to study online with us from the comfort of your home or on the go from the convenience of your phone",
    coming: "Coming Soon",
    facebook: "https://www.facebook.com/itiswritten/",
    instagram: "https://www.instagram.com/itiswrittenmedia/",
    youtube: "https://www.youtube.com/user/itiswritten",
    twitter: "https://twitter.com/itiswritten",
    copyright:
      "Copyright © 2020, It Is Written, Inc. All rights reserved. It Is Written is a registered service mark of It Is Written, Inc.",
  },

  contact: {
    contactUsH1: "Contact Us",
    contactUsB1a:
      "Our regular business hours are Monday–Thursday, 8:00 AM – 6:00 PM Eastern Standard Time. Please allow extra time for responses to messages sent to us over the weekend. ",
    contactUsB1b: "By Phone: ",
    contactUsNumber: "+1 844-974-8836 (844-WRITTEN)",
    contactUsB1c: "Or send a message using the form below.",
    contactUsB2: "This is a:",
    contactUsOption1: "Bible Question or Comment",
    contactUsOption2: "Technical Support Question or Comment",
    contactUsOption3: "Prayer Request",
    contactUsOption4: "Other",
    contactUsNamePlaceholder: "Your Name",
    contactUsEmailPlaceholder: "Your Email Address",
    contactUsMessagePlaceholder: "Your Message",
    contactUsSend: "Send",
    contactUsMessage1: "Message Sent",
    contactUsMessage2: "We'll get back to you!",
    contactUsErrorNoName: "No Name Provided",
    contactUsErrorNoEmail: "No Email Provided",
    contactUsErrorNoMessage: "No Message Provided",
    contactUsErrorUnknown:
      "That didn't quite work.  Please try again later, or try calling us",
  },

  auth: {
    authFirstName: "First Name",
    authLastName: "Last Name",
    authPhone: "Phone Number",
    authCity: "City",
    authCityOp: "City (Optional)",
    authState: "State",
    authZip: "Zip/Postal Code",
    authEmail: "Email",
    authEmailConf: "Email Confirmation",
    authPasswordConf: "Password Confirmation",
    authPassword: "Password",
    authChurchCode: "Church Code (Optional)",
    authAddChurch: "Add a Church Code",
    authRegister: "Register",
    authCancel: "Cancel",
    authToLogin: "Go to Login",
    authToRegister: "Go to Register",
    authForgotPassword: "Forgot Your Password",
    authResetPassword: "Reset Password",
    authKnownPassword: "I Know My Password",
    authDisclaimer:
      "By sending us your information you agree to allow us to contact you (Standard message and Data rates apply).",
    authErrorFirstName: "First Name Required",
    authErrorEmail: "Email Required",
    authErrorLastName: "Last Name Required",
    authErrorPassword: "Password Required",
    authErrorCity: "City Required",
    authErrorCountry: "Country Required",
    authErrorZip: "Zip/Postal Code Required",
    authErrorEmailVerbose:
      "Please enter an email for us to send your reset password.",
    authErrorCanadaZip: "Invalid Canadian Postal Code",
    authPhoneInvalid: "Invalid Phone Number",
  },

  guides: {
    guide: "Guide",
    myLessonsTitle: "My Study Guides",
    mylessonsSubtitle:
      "The It Is Written Guides are progressive. Complete the current one in the series to unlock the next. You can return here and review completed lessons at any time.",

    congrats: "Congratulations!",
    congratsBody:
      'You\'ve completed the online It Is Written Bible Study Guides!  We have lots of new features planned in the future, but until then, feel free to leave us a comment or two on the "Contact Us" page!',

    lessonHeaderWelcome: "Welcome",
    lessonHeaderWelcomeMessage:
      'Congratulations, you\'ve started the first guide!  There are 25 guides in this series.\n   When you complete one, you will unlock the next guide in the series.  Unlocked guides can be accessed from the "My Study Guides" link in the menu bar.\n   Each guide begins with an introduction - a short story that sets the stage for the guide.  Then, click the "Let\'s Get Started" button below to go to the first question.',
    lessonHeaderIntroductionTitle: "INTRODUCTION",
    lessonHeaderBackToGuide: "Go back to Guide",
    lessonTemplateShortHandQuestion: "Q",
    lessonTemplateContinue: "Continue",
    lessonTemplateGoBack: "Go Back",
    lessonTemplateNext: "Next Guide!",
    lessonTemplateFinished: "Finished!",
    lessonTemplateAnswerAbove: "Answer Above",
    lessonTemplateQuestion: "Question",

    questionTemplateExplore: "Click here to read this verse",
    questionTemplateGotQuestion: "Got a Question?",
    questionTemplateChurch: "Want to visit a church?",
    questionTemplateWordCloudInstructions:
      "Click or tap the correct answer to select it, then click/tap the appropriate blank. To remove an answer, double tap it to return it to the word cloud.",
    questionTemplateCheckboxInstructions: " Select all that apply.",
    questionTemplateRadioInstructions: "Select the correct answer.",
    questionTemplateTrue: "True",
    questionTempalteFalse: "False",
    questionTemplateYes: "Yes!",
    questionTemplateNo: "No Thanks",
    questionTemplateBack: "Back",
    questionTemplateVersion: "New King James Version",
    questionTemplateAsk: "Ask a question",
    questionTemplateQuestion: "Question",
    questionTemplateSubmit: "Submit",
    questionTemplateFindChurch: "Find a church near me",
    questionTemplateEmail: "Email",
    questionTemplateSend: "Send",

    questionTemplateErrorNeedMessage: "Need a message to submit",
    questionTemplateErrorNeedEmail: "We need an email to contact you.",
    questionTemplateErrorUnknown:
      "Oops, that didn't quite work.  Try again later or report a bug",

    aboutH1: "About the Bible Study Guides",
    aboutB1:
      "Using this site is completely FREE. There are 25 studies in the series covering major topics in the Bible. Completing one study unlocks the next study in the series. You can browse the 25 study titles here:",
    aboutH2: "How It Works",
    aboutB2a:
      'Nearly all of the questions in the studies are answered from the Bible directly. Most questions include the text of the Bible verse, with a couple missing words. Click a blank to select the correct word from the options presented. This feature is designed to help you get familiar with your own Bible, and also to help you think "about" the meaning and importance of the words in the verse. Once you’ve selected the missing words, the website will tell you immediately if your answers were right or wrong. When you get the correct answer you may advance to the next question. ',
    aboutB2b:
      "At the end of each guide is a personal commitment question, to help you apply what you learned in the guide to your own life. The guides were designed to be practical and down to earth.",
    aboutH3: "Creating an Account",
    aboutB3a:
      "Creating an account allows you to keep track of your progress, sync your progress between devices, and continue where you left off. Simply click the",
    aboutB3b: '"Sign Up"',
    aboutB3c: "menu option to get started",
    aboutH4: "The Purpose",
    aboutB4:
      "The Word of God was described by King David as being “a lamp to my feet and a light to my path” (Psalm 119:105). The Bible is a book like no other—containing the answers to life’s most challenging questions, and revealing to the world that there is a God who cares deeply for the human family. In fact, His love is so deep that He allowed His Son, Jesus, to die for the sins of the world. But like medicine in a bottle on a shelf, the Bible cannot truly work in a person’s life until it is internalized—until it becomes a part of the life of the person who holds it. The Bible connects us with God, the Source of life, and reveals to us the character of God and His glorious plans for an eternal future. The It Is Written Bible Study Guides will lead you on an in-depth study of the Bible. Important subjects will open up to your understanding, and you will encounter God’s promise of true peace and eternal security.",
    aboutB5a: "These guides are based on the printed",
    aboutB5b: "It Is Written Bible Study Guides",
    aboutB5c:
      ". To learn about these guides and related materials, such as our My Place With Jesus Bible Guides for kids, please visit the",
    aboutB5d: "It Is Written Store.",
    aboutLink:
      "https://itiswritten.shop/product-category/bible-study-guides/sets/",
  },
};
